<template>
	<div>
		<myheader :backFlag="true" :myBackgroundColor="'#98e2af'" headTitle="企业签约节能减碳助力值"></myheader>
		<div class="all_main">
			<div style="height: 83vh;overflow-y: auto;">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div style="position: relative;">
						<div v-if="list.length>0"
							style="position: absolute;top: 0;left: .1rem;height: 2rem;width: 2rem;z-index: 2;">
							<img src="../../assets/images/greenlifetop.svg"
								style="height: 2rem;width: 2rem;object-fit: fill;transform: rotate(-15deg);" />
						</div>
						<van-list v-model="listloading" :finished="listfinished" finished-text="没有更多了" @load="onLoad"
							v-show="list.length>0">
							<div v-for="(item,index) in list" :key="index" v-show="list.length>0"
								@click="itemClick(item)">
								<div class="margin_bottom_5 parent" :class="{firstItem:index===0,otherItem:index!==0}"
									:style="{'height':index===0?'7rem':'6rem'}">
									<div class="all_tips_content_card_padding8">
										<div class="text14 textcolor333 font_weight_bold">{{item.corpName}}</div>
										<div class="text12 textcolor999 margin_top_5">{{'企业代码： '+item.corpCode}}</div>
										<div class="display_flex margin_top_5">
											<span class="display_block text14 textcolor666 font_weight_bold"
												style="width: 50%;">{{'签订合同：'+item.contractCount+'份'}}</span>
											<span
												class="display_block text14 textcolor666 font_weight_bold all_text_right"
												style="width: 50%;">{{'减少碳排放：'+(Tool.isNoEmpty(item.corpScore)?item.corpScore:'0')+'g'}}</span>
										</div>
									</div>
								</div>
							</div>
						</van-list>
						<van-empty style="margin-top: 10vh;" description="暂无数据" v-show="list.length===0" />
					</div>
				</van-pull-refresh>
			</div>
		</div>
		<div style="position: fixed; bottom: 1rem; left: 0;right: 0;">
			<span class="text18 textcolor98e2af all_text_center display_block" style="position: relative; width: 60%;left: 20%;font-style: oblique">签约减碳，绿色共创</span>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Empty,
		PullRefresh,
		List,
	} from 'vant';
	export default {
		components: {
			[Empty.name]: Empty,
			[PullRefresh.name]: PullRefresh,
			[List.name]: List,
		},
		data() {
			return {
				//企业id
				corpId: '',
				//每页数量
				pageSize: 10,
				//第几页
				pageNum: 0,
				//是否刷新
				refreshing: false,
				//加载中
				listloading: false,
				//是否全部加载
				listfinished: false,
				//
				list: [],
				first: require('@/assets/images/greenlife0.svg'),
				other: require('@/assets/images/greenlife1.svg'),
			}
		},
		methods: {
			//
			itemClick(item) {
				this.$router.push({
					path: '/energyconservationcorplistdetails',
					query: {
						corpId: item.corpId,
						corpName: item.corpName,
						corpScore: item.corpScore
					}
				})
			},
			//
			onRefresh() {
				this.$store.dispatch(this.$LoadShow, true)
				this.listfinished = false;
				// 将 loading 设置为 true，表示处于加载状态
				this.listloading = true;
				this.pageNum = 0
				this.onLoad();
			},
			//
			onLoad() {
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
				}
				this.pageNum++
				this.queryContractScore()
			},
			//
			queryContractScore() {
				this.$post('/score/m/api/queryCorpScoresStat', {
						pageParams: {
							"current": this.pageNum,
							"desc": true,
							"orderBy": "",
							"size": this.pageSize
						}
					})
					.then(res => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.list = this.list.concat(res.data.records);
							// 加载状态结束
							this.listloading = false;
							//数据全部加载完成
							if (this.list.length >= res.data.total) {
								this.listfinished = true;
							}
						}
					})
					.catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
					})
			},
			//初始化
			init() {
				this.onRefresh()
			},
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.parent {}


	.firstItem {
		padding: 1.5rem .8rem .5rem .8rem;
		background-image: url('../../assets/images/greenlife0.svg');
	}

	.otherItem {
		padding: .5rem .8rem;
		background-image: url('../../assets/images/greenlife1.svg');
	}
</style>

<!-- #98e2af #98e2af
#dbf1e3 #dbf2e3
#dff0e5 #e0f0e5
#b5e6c4 #b5e6c4 -->